import {
  ArrayParam,
  StringParam,
  useQueryParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import type { FilterOptions } from "common/types";

const defaultFilteredBy: FilterOptions = "all";

export default function useInboxFilters() {
  const [filteredBy, setFilteredBy] = useQueryParam(
    "filter",
    withDefault(StringParam, defaultFilteredBy),
  ) as [FilterOptions, (value: FilterOptions) => void];

  const [selectedFilters, setSelectedFilters] = useQueryParams(
    {
      accountIds: withDefault(ArrayParam, []),
      campaignIds: withDefault(ArrayParam, []),
      labelIds: withDefault(ArrayParam, []),
    },
    {
      removeDefaultsFromUrl: true,
      updateType: "replaceIn",
    },
  );

  function clearAllFilters() {
    setSelectedFilters({
      accountIds: [],
      campaignIds: [],
      labelIds: [],
    });
    setFilteredBy(defaultFilteredBy);
  }

  const hasAnyFilters =
    filteredBy !== "all" ||
    !!selectedFilters.accountIds.length ||
    !!selectedFilters.labelIds.length ||
    !!selectedFilters.campaignIds.length;

  return {
    filteredBy,
    setFilteredBy,
    selectedFilters,
    setSelectedFilters,
    hasAnyFilters,
    clearAllFilters,
  };
}
